import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Tramite } from './tramite.models';

@Injectable({
  providedIn: 'root'
})
export class TramiteService {
  url: string;
  token: string;
  endpoint = 'tramites';

  constructor(private http: HttpClient) {}

  getMockTramite(): Observable<Tramite[]> {
    return this.http.get<Tramite[]>(`assets/mock/tramite.json`, {
      params: { token: this.token }
    });
  }

  getTramite(): Observable<Tramite[]> {
    return this.http.get<Tramite[]>(`${this.url}/${this.endpoint}/`);
  }

  addTramite(Tramite: Tramite): Observable<Tramite> {
    return this.http.post<Tramite>(`${this.url}/${this.endpoint}/`, {
      ...Tramite
    });
  }

  changeTramite(p: Tramite): Observable<Tramite> {
    return this.http.patch<Tramite>(`${this.url}/${this.endpoint}/${p.id}/`, {
      ...p
    });
  }

  deleteTramite(p: Tramite): Observable<Tramite> {
    return this.http.delete<Tramite>(`${this.url}/${this.endpoint}/${p.id}`, {
      params: { token: this.token }
    });
  }
}
